// GENERATED by scripts/build-icons.mjs from icons/briefcase.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Briefcase = createIcon('briefcase', [
  ['path', { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" }],
  ['rect', { width: "20", height: "14", x: "2", y: "6", rx: "2" }],
])
